import React from 'react';
import App from '../utils/app';
const EncuestaRetiro = () => {

  return (
    <App/>
  );
}

export default EncuestaRetiro;